import { PickupTaskState } from "../../../enums/tasks";

export const PENDING = PickupTaskState.ASSIGNED as string
export const IN_PROGRESS = `${PickupTaskState.IN_PROGRESS},${PickupTaskState.PICKED_UP}`
export const FINISHED = `${PickupTaskState.COMPLETED},${PickupTaskState.FAILED},${PickupTaskState.CANCELLED}`
export const ALL = `${PickupTaskState.ASSIGNED},${PickupTaskState.IN_PROGRESS},${PickupTaskState.PICKED_UP},${PickupTaskState.COMPLETED},${PickupTaskState.FAILED},${PickupTaskState.CANCELLED}`

export type TASK_STATE_CATEGORY =
    PickupTaskState.ASSIGNED
    | `${PickupTaskState.IN_PROGRESS},${PickupTaskState.PICKED_UP}`
    | `${PickupTaskState.COMPLETED},${PickupTaskState.FAILED},${PickupTaskState.CANCELLED}`
    |  `${PickupTaskState.ASSIGNED},${PickupTaskState.IN_PROGRESS},${PickupTaskState.PICKED_UP},${PickupTaskState.COMPLETED},${PickupTaskState.FAILED},${PickupTaskState.CANCELLED}`